module.exports = __webpack_public_path__ + "937865ddbe3f578111eb395221678616.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/kloudless/icons/sharepointonline.png
 ** module id = 1480
 ** module chunks = 0
 **/